module.exports = __webpack_public_path__ + "img/Group1.0fa13d8c.svg";